import { Component, HostListener, Input,OnInit} from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-product-details-carousel',
  templateUrl: './product-details-carousel.component.html',
  styleUrls: ['./product-details-carousel.component.scss']
})
export class ProductDetailsCarouselComponent implements OnInit {
  showProducts:boolean;
  _screenSize:any;
  public config: SwiperConfigInterface = {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,
  };
  @Input() childClass:string = '';
   @Input() displayProducts = [
    {
      img: "../../../../assets/images/productRating/product1.png",
      startext:
        "Sometimes Change is necessary and I found mine here.",
      author: "DR. JACOB",
      type: "Customer",
      small: true,
      medium: false,
      left: false,
      leftbig: false,
      boxTitle: 'COMMON SENSE',
      boxContent: 'Loyalty Rewards Program'
    },
    {
      img: "../../../../assets/images/productRating/product2.png",
      startext:
        "I thank God I found a company that cares more about it's distributor's and customers than it does about itself.",
      author: "PAULA WANGNER",
      type: "Customer",
      small: true,
      medium: false,
      left: false,
      leftbig: false,
      boxTitle: 'COMMON SENSE',
      boxContent: 'Loyalty Rewards Program'
    },
    {
      img: "../../../../assets/images/productRating/product3.png",
      startext:
        "Super products, especially now when we need to keep our immune system strong!",
      author: "DR. KARL ANDERSON",
      type: "BrainSense",
      small: true,
      medium: false,
      left: false,
      leftbig: false,
      boxTitle: 'COMMON SENSE',
      boxContent: 'Loyalty Rewards Program'
    },
    {
      img: "../../../../assets/images/productRating/product1.png",
      startext:
        "This is the best tasting mangosteen drink I have tried. I crave it everyday.",
      author: "ROBIN",
      type: "Customer",
      small: true,
      medium: false,
      left: false,
      leftbig: false,
      boxTitle: 'COMMON SENSE',
      boxContent: 'Loyalty Rewards Program'
    },
   ];
  testimonialImageUrl = '../../../../assets/images/new/BrainSenseNEW.webp';
  constructor() { }
  ngAfterViewInit(): void {
    this._screenSize=window.innerWidth
    this.config = {
      mousewheel:false,
      observer: true,
      slidesPerView: 1,
      spaceBetween: 10,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: true,
      preloadImages: true,
      //lazy: true,
      breakpoints: {
        480: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1,
        },
        769: {
          slidesPerView: 2,
        },
        1025: {
          slidesPerView: 2,
        },
        1026: {
          slidesPerView: 1,
        },
        1280: {
          slidesPerView: 1,
        },
      },
    };
  }
  ngOnInit(): void {
    this._screenSize=window.innerWidth
    if(this.displayProducts.length <= 1){
      this.showProducts = true;
    }else{
      this.showProducts=true;
    }
  }
  @HostListener('window:resize', ['$event'])
  onWindowResize(event: Event) {
    this.windowResize(event);
  }
  windowResize(event: Event): void {
    this._screenSize=window.innerWidth
    if(this._screenSize<=975) {

    }
  }
}
